import { useLanguage } from "@/i18n/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang, t } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label={t.lang.aria}
      className={`relative inline-flex items-center bg-ink-soft border border-ink-line rounded-full p-0.5 ${className}`}
    >
      <span
        aria-hidden
        className={`absolute top-0.5 bottom-0.5 w-1/2 rounded-full bg-gold transition-transform duration-300 ease-out ${
          lang === "es" ? "translate-x-full" : "translate-x-0"
        }`}
        style={{ left: "2px", width: "calc(50% - 2px)" }}
      />
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`relative z-10 px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full transition-colors duration-200 ${
          lang === "en" ? "text-ink" : "text-white/70 hover:text-white"
        }`}
      >
        <span className="mr-1">🇺🇸</span>EN
      </button>
      <button
        type="button"
        data-testid="lang-es"
        onClick={() => setLang("es")}
        className={`relative z-10 px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full transition-colors duration-200 ${
          lang === "es" ? "text-ink" : "text-white/70 hover:text-white"
        }`}
      >
        <span className="mr-1">🇲🇽</span>ES
      </button>
    </div>
  );
}
